import { action, integrationScriptLoadState } from 'js/hooks/auth/pas';

/**
 *
 * @param {Object} options
 */
export const rfidLogin = (options) => {
    const params = [options.userName, options.password, options.languageCode];

    return action('iapiLoginIdTokenCodeAndPassword', 'iapiCALLOUT_LOGIN', params)
        .catch((error) => {
            const response = error.response || error;

            if (response?.data?.sessionValidationData) {
                return response;
            }

            return Promise.reject(error);
        });
};

export const changeValidationPassword = options => action(
    'iapiValidatePasswordChange', 'iapiCALLOUT_SESSIONVALIDATION',
    [options.oldPassword, options.password, 0, 1]);

export const setClientSkin = clientSkin => integrationScriptLoadState
    .then(() => window.iapiSetClientSkin(clientSkin));

export const lightLoginWithPin = ({ cardNumber, pin, languageCode = 'en' }) =>
    action('iapiLoginIdTokenCodeAndPin', 'iapiCALLOUT_LOGIN', [cardNumber, pin, languageCode]);

export const loginWithProvisional = ({
    lastName,
    birthDate,
    zip,
    username,
    language = 'en'
}) => {
    window.iapiLoginWithProvisional = window.loginWithProvisional;

    return action('iapiLoginWithProvisional', 'iapiCALLOUT_LOGIN', [{
        lastName,
        birthDate,
        zip,
        username,
        language
    }]);
};
